export default __webpack_public_path__ + "static/media/ddc.59808576.png";